import axios from 'axios';
import { ApiServiceBase, IApiServiceBase } from './apiServiceBase';
import { CentralTrackingSignalRModel } from '@app/domain/interfaces/centralTracking/CentralTrackingSignalRModel';
import appSettings from '@app/config/appsettings';

export default interface ISignalRService
  extends IApiServiceBase<CentralTrackingSignalRModel, CentralTrackingSignalRModel> {
  getUrlAndAccessToken(): Promise<CentralTrackingSignalRModel>;
}

export class SignalRService
  extends ApiServiceBase<CentralTrackingSignalRModel, CentralTrackingSignalRModel>
  implements ISignalRService
{
  async getUrlAndAccessToken(): Promise<CentralTrackingSignalRModel> {
    try {
      const { data } = await axios
        .create()
        .get<CentralTrackingSignalRModel>(`${appSettings().APIs.Acompanhamento.UrlBase}/api/signalr/negotiate`);

      return data;
    } catch (error) {
      throw error;
    }
  }
}
